import React from 'react';
import { IconPropType } from '../../../../Interfaces/IconPropType';
export const Delomraade = (props: IconPropType) => {
  const { width, height } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : height ? height * (15 / 16) : 15}
      height={height ? height : width ? width * (16 / 15) : 16}
      viewBox="0 0 15 16"
      version="1.1"
    >
      <path
        d="M1 3.51V14h8.14V9.33H14V1H5.09z"
        fill="#DEE1E4"
        stroke="#425971"
        fillRule="evenodd"
        fillOpacity=".75"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Delomraade;
